import Offices from 'client/common/components/offices';

import './index.css';

export default Offices;
